import "./CurrencyDropdown.scss";
import { useState, useRef } from "react";
import { CurrencyAssetResponse } from "../../models/otc";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";
import { availableCurrencies } from "../../constants/availableCurrencies";
interface CurrencyDropdownProps {
  currencies: CurrencyAssetResponse[];
  url?: string;
  value: CurrencyAssetResponse;
  type: string;
  onChange: (value: CurrencyAssetResponse) => void;
}

const CurrencyDropdown = ({
  currencies,
  value,
  onChange,
  type,
}: CurrencyDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const listRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const imageSrc = availableCurrencies[value.symbol] || null;

  useOnClickOutside(listRef, () => {
    setIsOpen(false);
  });
  const filteredCurrencies = currencies?.filter((currency) => {
    if (type === "FIAT") {
      return (
        currency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        currency.symbol.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return (
        currency.blockchain?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        currency.symbol.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  });

  return (
    <div
      className="currencies-area"
      ref={listRef}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="currency-row">
        {imageSrc && <img src={imageSrc} alt={value.symbol} />}
        <div className="currency-column">
          <div className="short-currency">{value.symbol}</div>
          <div className="full-currency">
            {type === "FIAT" ? value.name : value.blockchain}
          </div>
        </div>
      </div>
      {!isOpen ? (
        <ArrowDropUpIcon sx={{ fontSize: 60 }} />
      ) : (
        <ArrowDropDownIcon sx={{ fontSize: 60 }} />
      )}

      {isOpen && (
        <div className="currency-list-area">
          <div className="search-row">
            <SearchIcon />
            <input
              type="text"
              placeholder={t("exchange.placeholders.search")}
              value={searchTerm}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              className="currency-search-input"
            />
          </div>

          <div className="currency-list">
            {filteredCurrencies.map((currency) => {
              const imageSrc = availableCurrencies[currency.symbol] || null;
              return (
                <div
                  className="currency-dropdow-row"
                  key={currency.id}
                  onClick={() => {
                    setIsOpen(false);
                    onChange(currency);
                  }}
                >
                  {imageSrc && <img src={imageSrc} alt={currency.symbol} />}
                  <div className="currency-symbol">{currency.symbol}</div>
                  <div className="currency-name">
                    {type === "FIAT" ? currency.name : currency.blockchain}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencyDropdown;
